/** Number formatting for Indian markets. Uses the real minus sign (U+2212). */

const MINUS = '−'

const cache = new Map<string, Intl.NumberFormat>()
function nf(min: number, max: number): Intl.NumberFormat {
  const key = `${min}:${max}`
  let f = cache.get(key)
  if (!f) {
    f = new Intl.NumberFormat('en-IN', { minimumFractionDigits: min, maximumFractionDigits: max })
    cache.set(key, f)
  }
  return f
}

/** 150838 → "1,50,838"; negative values use U+2212. */
export function formatNumber(value: number, decimals = 2): string {
  const s = nf(decimals, decimals).format(Math.abs(value))
  return value < 0 ? MINUS + s : s
}

/** Signed value: +5.60 / −197.00 / 0.00 */
export function formatSigned(value: number, decimals = 2): string {
  const s = nf(decimals, decimals).format(Math.abs(value))
  if (value > 0) return `+${s}`
  if (value < 0) return MINUS + s
  return s
}

export function formatPercent(value: number, decimals = 2, signed = true): string {
  return `${signed ? formatSigned(value, decimals) : formatNumber(value, decimals)}%`
}

export function formatRupees(value: number, decimals = 0): string {
  return `₹${formatNumber(value, decimals)}`
}

export type Direction = 'up' | 'down' | 'flat'
export function directionOf(value: number): Direction {
  return value > 0 ? 'up' : value < 0 ? 'down' : 'flat'
}

/** HH:MM in Asia/Kolkata for an ISO timestamp. */
export function formatTimeIST(iso: string): string {
  return new Intl.DateTimeFormat('en-IN', {
    hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'Asia/Kolkata',
  }).format(new Date(iso))
}
